import React, {useEffect, useState} from "react";
import About from "./components/About";
import Alert from "./components/Alert";
import Navbar from "./components/Navbar";
import TextForm from "./components/TextForm";
// import ReactDOM from "react-dom";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";

function App() {
  const [darkMode, setDarkMode] = useState(false); //dark mode enabled or not
  const [alert, setAlert] = useState(null);

  const showAlert = (message, type)=>{
    setAlert({
      msg: message,
      type: type
    })
    setTimeout(()=>{setAlert(null)}, 2000)
  }

  const toggleMode = ()=>{
    setDarkMode(prevState => !prevState);

    if(darkMode === false){
      showAlert("Dark mode has been enabled", "success");
    }
    else{
      showAlert("Light mode has been enabled", "success");
    }
    
  }
  useEffect(()=>{
    document.body.style.backgroundColor=darkMode?"#23272F":"white";
    document.body.style.backgroundColor=darkMode?"#001223":"white";
    document.body.style.color=darkMode?"white":"black";
    // document.getElementById("myBox").style.backgroundColor=darkMode?"#212529":"white";
    // document.getElementById("myBox").style.backgroundColor=darkMode?"#212529":"white";
    // document.getElementById("myBox").style.color=darkMode?"white":"black";
    darkMode?showAlert("Dark mode has been enabled", ""):showAlert("Light mode has been enabled", "")

  }, [darkMode]);

  return (
    <>

    <Router>
      <Navbar title="Textutlis" aboutText="About Textutlis" darkMode={darkMode} toggleMode={toggleMode}/>
      <Alert alert={alert} />
      <div className="container my-3">
      <Switch>
          <Route exact path="/about">
            <About />
          </Route>
          <Route exact path="/">
              <TextForm heading="Enter the text to analyze" showAlert={showAlert}/>
          </Route>
        </Switch>
    </div>
    </Router>
     
    </>
  );
}

export default App;
